import { Component, EventEmitter, Input, Output } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';
import { PackingPlanningModel } from 'src/app/models/PackingPlanningModel';
import { PackingPlanningService } from 'src/app/services/packing-planning/packing-planning.service';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPen } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-planning-table',
  templateUrl: './planning-table.component.html',
  styleUrl: './planning-table.component.css'
})
export class PlanningTableComponent {

  faTrash = faTrash
  faPen = faPen

  @Input() toggle: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();
  tripToEdit!: PackingPlanningModel | null
  data$: Observable<PackingPlanningModel[]> = new Observable()


  isLoading: boolean = false;
  showForm: boolean = false
  dropdownOpen: boolean = false
  selectedOption: string = 'time-table'
  options = ['container', 'MG', 'time-table']

  constructor(private packService: PackingPlanningService) {
  }

  ngOnInit() {
    this.loadPackingPlanningTableAlt()
  }

  loadPackingPlanningTableAlt() {
    this.isLoading = true
    this.data$ = this.packService.getAllTripsObs()

    const observable = this.packService.getAllTripsObs()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      );

    observable.subscribe({
      next: (dados) => { },
      error: (err) => {
        console.error('ERRO NA REQUISIÇÃO FISCO', err);
      }
    });

    this.data$ = observable;
  }

  deleteTripById(tripId: number, tripCode: string) {
    if (confirm(`Deseja realmente excluir a viagem ${tripCode}?`)) {
      this.packService.deletePlanningTrip(tripId).subscribe({
        next: () => {
          alert("Viagem excluída com sucesso");
          this.data$ = this.data$.pipe(
            map(response => response.filter(r => r.id !== tripId)));
        },
        error: (err) => {
          console.error("Erro ao excluir viagem:", err);
          alert("Erro ao excluir a viagem");
        },
      });
    }
  }

  openEditForm(trip: any) {
    this.showForm = true
    this.tripToEdit = trip
  }

  onToggleClick(event: MouseEvent) {
    event.stopPropagation();
    this.toggleChange.emit(false);
    this.toggle = !this.toggle;
  }

  toggleForm() {
    this.showForm = !this.showForm
    if (!this.showForm) {
      this.tripToEdit = null
    }
  }

  onDataUpdated() {
    this.loadPackingPlanningTableAlt()
    this.showForm = false
    this.tripToEdit = null
  }

  /* DROPDOWN FILTER */

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen
  }

  selectOption(option: string) {
    this.selectedOption = option
    this.dropdownOpen = false
    this.applyFilter(option)
  }

  applyFilter(value: string) {
    this.data$ = this.packService.getTripsByClassification(value)
  }

}
